/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** SystemDictionarySlugs */
export enum SystemDictionarySlugs {
  Tags = "tags",
  Brands = "brands",
  Categories = "categories",
}

/** OrderApprovalRule */
export enum OrderApprovalRule {
  NotNeeded = "not_needed",
  OrderApprovalChain = "order_approval_chain",
}

/** LimitOwnerType */
export enum LimitOwnerType {
  User = "user",
  UserGroup = "user_group",
}

/** CatalogVisibilityRule */
export enum CatalogVisibilityRule {
  Hidden = "hidden",
  VisibleToGroups = "visible_to_groups",
  VisibleToUsers = "visible_to_users",
  Public = "public",
}

/** CatalogType */
export enum CatalogType {
  Manual = "manual",
  Mirror = "mirror",
  Dynamic = "dynamic",
}

/** CatalogTab */
export enum CatalogTab {
  Active = "active",
  Archived = "archived",
}

/** CatalogStatus */
export enum CatalogStatus {
  Scheduled = "scheduled",
  Active = "active",
  Expired = "expired",
  Archived = "archived",
}

/** Body_uploadCatalogCover */
export interface BodyUploadCatalogCover {
  /**
   * Media
   * Image file
   * @format binary
   */
  media: File;
}

/** Body_uploadProductImage */
export interface BodyUploadProductImage {
  /**
   * Media
   * Image file
   * @format binary
   */
  media: File;
}

/** CartItemProductSchema */
export interface CartItemProductSchema {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
  /** Code */
  code: string | null;
  /** Description */
  description: string | null;
  /** Package Amount */
  package_amount?: number | null;
}

/** CartItemSchema */
export interface CartItemSchema {
  /** Uid */
  uid: string;
  product: CartItemProductSchema;
  /** Quantity */
  quantity: number;
  /** Volume */
  volume: string;
  /** Price */
  price: string;
  /** Weight */
  weight: string;
  /** Is Quantity Multiple */
  is_quantity_multiple: boolean;
}

/** CartSchema */
export interface CartSchema {
  /** Uid */
  uid: string | null;
  /** Items */
  items: CartItemSchema[] | null;
  /** Items Total */
  items_total: number;
  total: CartTotalSchema | null;
  /**
   * Show Multiplicity Indicator
   * @default false
   */
  show_multiplicity_indicator?: boolean;
}

/** CartTotalSchema */
export interface CartTotalSchema {
  /** Quantity */
  quantity: number;
  /** Volume */
  volume: string;
  /** Price */
  price: string;
  /** Weight */
  weight: string;
}

/** CatalogCoverSchema */
export interface CatalogCoverSchema {
  /** Uid */
  uid: string;
  variants: CatalogCoverVariantsSchema;
}

/** CatalogCoverVariantsSchema */
export interface CatalogCoverVariantsSchema {
  /** size: 64x64 */
  thumbnailSmall?: ImageVariant;
  /** size: 260x150 */
  thumbnail?: ImageVariant;
}

/** CatalogNotUniqueError */
export interface CatalogNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "catalog_name_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CatalogSchema */
export interface CatalogSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Is Pinned */
  is_pinned: boolean;
  status: CatalogStatus;
  /** Archived At */
  archived_at?: string | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  cover: CatalogCoverSchema | null;
  warehouse: CatalogWarehouseSchema | null;
  process: ProcessSchema | null;
  project: ProjectSchema | null;
  /** CatalogPermissions */
  $permissions: {
    /** Delete */
    delete?: boolean;
    /** Manage Products */
    manage_products?: boolean;
    /** Update */
    update?: boolean;
    /** View */
    view?: boolean;
    /** View Cart */
    view_cart?: boolean;
    /** View Products */
    view_products?: boolean;
    /** View Settings */
    view_settings?: boolean;
    /** Import Orders */
    import_orders?: boolean;
  };
}

/** CatalogSettingsSchema */
export interface CatalogSettingsSchema {
  visibility_rule: CatalogVisibilityRule;
  catalog_type: CatalogType | null;
  /** Visible To Users */
  visible_to_users: SimpleUserSchema[] | null;
  /** Visible To User Groups */
  visible_to_user_groups: SimpleUserGroupSchema[] | null;
  order_approval_chain: SimpleOrderApprovalChainSchema | null;
  order_approval_rule: OrderApprovalRule;
  /** Show Multiplicity Indicator */
  show_multiplicity_indicator: boolean;
}

/** CatalogWarehouseSchema */
export interface CatalogWarehouseSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** ContextSchema */
export interface ContextSchema {
  scope: ContextScopeSchema;
}

/** ContextScopeSchema */
export interface ContextScopeSchema {
  /** ScopePermissions */
  $permissions: {
    /** Create Products */
    create_products?: boolean;
    /** Create Catalogs */
    create_catalogs?: boolean;
    /** Upload Catalog Covers */
    upload_catalog_covers?: boolean;
    /** Upload Product Images */
    upload_product_images?: boolean;
    /** View Catalogs */
    view_catalogs?: boolean;
    /** View Products */
    view_products?: boolean;
    /** View Dictionaries */
    view_dictionaries?: boolean;
    /** Export Products */
    export_products?: boolean;
    /** Export Catalogs */
    export_catalogs?: boolean;
  };
}

/** CreateCatalogSchema */
export interface CreateCatalogSchema {
  /** Name */
  name: string;
  /** Process Uid */
  process_uid?: string | null;
  /** Project Uid */
  project_uid?: string | null;
  /** Cover Uid */
  cover_uid?: string | null;
  /** Warehouse Uid */
  warehouse_uid?: string | null;
  /** Product Uids */
  product_uids?: string[] | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  settings: CreateCatalogSettingsSchema;
}

/** CreateCatalogSettingsSchema */
export interface CreateCatalogSettingsSchema {
  visibility_rule: CatalogVisibilityRule;
  catalog_type?: CatalogType | null;
  /** Visible To User Group Uids */
  visible_to_user_group_uids?: string[] | null;
  /** Visible To User Ids */
  visible_to_user_ids?: number[] | null;
  /**
   * Show Multiplicity Indicator
   * @default false
   */
  show_multiplicity_indicator?: boolean;
  order_approval_rule: OrderApprovalRule;
  /** Order Approval Chain Uid */
  order_approval_chain_uid?: string | null;
}

/** CreateDictionaryItemDTO */
export interface CreateDictionaryItemDTO {
  /** Title */
  title: string;
}

/** CreateLimitSchema */
export interface CreateLimitSchema {
  limit_owner_type: LimitOwnerType;
  /** Limit Owner Uid */
  limit_owner_uid: string;
  /** @default "quantity" */
  limit_type?: LimitType;
  /** Items */
  items: LimitItemUpsertSchema[];
}

/** CreateProductSchema */
export interface CreateProductSchema {
  /** Title */
  title: string;
  /** Code */
  code?: string | null;
  /** Description */
  description?: string | null;
  /** Weight */
  weight?: number | string | null;
  /** Length */
  length?: number | string | null;
  /** Height */
  height?: number | string | null;
  /** Width */
  width?: number | string | null;
  /** Price */
  price?: number | string | null;
  /** Package Amount */
  package_amount?: number | null;
  /** Manual Stock */
  manual_stock?: number | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * Tags Ids
   * @default []
   */
  tags_ids?: number[];
  /** Category Id */
  category_id?: number | null;
  /** Brand Id */
  brand_id?: number | null;
  /** Image Uids */
  image_uids?: string[] | null;
}

/** DeleteCartItemResponseSchema */
export interface DeleteCartItemResponseSchema {
  /** Cart Items Total */
  cart_items_total: number;
  cart_total: CartTotalSchema;
}

/** DictionaryItemNotUniqueError */
export interface DictionaryItemNotUniqueError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "dictionary_title_not_unique";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** DictionaryItemSchema */
export interface DictionaryItemSchema {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** DictionaryItemPermissions */
  $permissions: {
    /** Delete */
    delete?: boolean;
  };
}

/** DictionarySchema */
export interface DictionarySchema {
  /** Id */
  id: number;
  /** Slug */
  slug: string;
  /** Title */
  title: string;
  /** DictionaryPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Create Item */
    create_item?: boolean;
  };
}

/** ExportResponseSchema */
export interface ExportResponseSchema {
  /** Filename */
  filename: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ImageVariant */
export interface ImageVariant {
  /** Url */
  url?: string;
}

/** LimitItemSchema */
export interface LimitItemSchema {
  /** Uid */
  uid: string;
  /** Product Uid */
  product_uid: string;
  /** Limit Quantity */
  limit_quantity: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** LimitItemUpsertSchema */
export interface LimitItemUpsertSchema {
  /** Product Uid */
  product_uid: string;
  /**
   * Limit Quantity
   * @min 0
   */
  limit_quantity: number;
}

/** LimitSchema */
export interface LimitSchema {
  /** Uid */
  uid: string;
  /** Catalog Uid */
  catalog_uid: string;
  limit_owner_type: LimitOwnerType;
  /** Limit Owner Uid */
  limit_owner_uid: string;
  limit_type: LimitType;
  /** Is Active */
  is_active: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Items */
  items?: LimitItemSchema[];
}

/** LimitType */
export type LimitType = "quantity";

/** PhotoImageVariantsSchema */
export interface PhotoImageVariantsSchema {
  /** size: 64x64 */
  thumbnailSmall?: ImageVariant;
  /** size: 260x150 */
  thumbnail?: ImageVariant;
  /** size: fit-in/540x770 */
  normal?: ImageVariant;
  /** size: fit-in/1960x1280 */
  fullscreen?: ImageVariant;
}

/** ProcessSchema */
export interface ProcessSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** ProductCartItemSchema */
export interface ProductCartItemSchema {
  /** Uid */
  uid: string;
  /** Quantity */
  quantity: number;
}

/** ProductImageSchema */
export interface ProductImageSchema {
  /** Uid */
  uid: string;
  variants: PhotoImageVariantsSchema;
}

/** ProductNotInCatalogError */
export interface ProductNotInCatalogError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "product_not_in_catalog";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ProductUidDTO */
export interface ProductUidDTO {
  /** Product Uid */
  product_uid: string;
}

/** ProjectSchema */
export interface ProjectSchema {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
}

/** RecordsListGenericSchema[CatalogSchema] */
export interface RecordsListGenericSchemaCatalogSchema {
  /** Items */
  items: CatalogSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveLimitSchema] */
export interface RecordsListGenericSchemaRetrieveLimitSchema {
  /** Items */
  items: RetrieveLimitSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[ViewProductInCatalogSchema] */
export interface RecordsListGenericSchemaViewProductInCatalogSchema {
  /** Items */
  items: ViewProductInCatalogSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[ViewProductSchema] */
export interface RecordsListGenericSchemaViewProductSchema {
  /** Items */
  items: ViewProductSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RemoveCartItemsDTO */
export interface RemoveCartItemsDTO {
  /** Item Uids */
  item_uids: string[];
}

/** ReplaceLimitItemsSchema */
export interface ReplaceLimitItemsSchema {
  /** Items */
  items: LimitItemUpsertSchema[];
}

/** RetrieveLimitSchema */
export interface RetrieveLimitSchema {
  /** Uid */
  uid: string;
  /** Catalog Uid */
  catalog_uid: string;
  limit_owner_type: LimitOwnerType;
  /** Limit Owner Uid */
  limit_owner_uid: string;
  limit_type: LimitType;
  /** Is Active */
  is_active: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Items */
  items?: LimitItemSchema[];
  /** Limit Owner Name */
  limit_owner_name: string;
}

/** SimpleDictionaryItemSchema */
export interface SimpleDictionaryItemSchema {
  /** Id */
  id: number;
  /** Title */
  title: string;
}

/** SimpleOrderApprovalChainSchema */
export interface SimpleOrderApprovalChainSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** SimpleUserGroupSchema */
export interface SimpleUserGroupSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Cluster */
  cluster?: string | null;
}

/** SimpleUserSchema */
export interface SimpleUserSchema {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** UpdateCartItemDTO */
export interface UpdateCartItemDTO {
  /** Product Uid */
  product_uid: string;
  /**
   * Quantity
   * @min 1
   * @default 1
   */
  quantity?: number;
  /**
   * Updating
   * Обновлять существующую позицию
   * @default true
   */
  updating?: boolean;
}

/** UpdateCartItemResponseSchema */
export interface UpdateCartItemResponseSchema {
  cart_item: CartItemSchema | null;
  /** Cart Items Total */
  cart_items_total: number;
  cart_total: CartTotalSchema;
  /** Requested Quantity */
  requested_quantity: number;
  /** Granted Quantity */
  granted_quantity: number;
  /** Was Adjusted */
  was_adjusted: boolean;
}

/** UpdateCatalogSchema */
export interface UpdateCatalogSchema {
  /** Name */
  name: string;
  /** Process Uid */
  process_uid?: string | null;
  /** Project Uid */
  project_uid?: string | null;
  /** Cover Uid */
  cover_uid?: string | null;
  /** Warehouse Uid */
  warehouse_uid?: string | null;
  /** Product Uids */
  product_uids?: string[] | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  settings: CreateCatalogSettingsSchema;
}

/** UpdateProductSchema */
export interface UpdateProductSchema {
  /** Title */
  title: string;
  /** Code */
  code?: string | null;
  /** Description */
  description?: string | null;
  /** Weight */
  weight?: number | string | null;
  /** Length */
  length?: number | string | null;
  /** Height */
  height?: number | string | null;
  /** Width */
  width?: number | string | null;
  /** Price */
  price?: number | string | null;
  /** Package Amount */
  package_amount?: number | null;
  /** Manual Stock */
  manual_stock?: number | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * Tags Ids
   * @default []
   */
  tags_ids?: number[];
  /** Category Id */
  category_id?: number | null;
  /** Brand Id */
  brand_id?: number | null;
  /** Image Uids */
  image_uids?: string[] | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** ViewProductInCatalogSchema */
export interface ViewProductInCatalogSchema {
  /** Title */
  title: string;
  /** Code */
  code?: string | null;
  /** Description */
  description?: string | null;
  /** Weight */
  weight?: string | null;
  /** Length */
  length?: string | null;
  /** Height */
  height?: string | null;
  /** Width */
  width?: string | null;
  /** Price */
  price?: string | null;
  /** Package Amount */
  package_amount?: number | null;
  /** Manual Stock */
  manual_stock?: number | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Uid */
  uid: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Images */
  images: ProductImageSchema[];
  /** Tags */
  tags: SimpleDictionaryItemSchema[];
  brand: SimpleDictionaryItemSchema | null;
  category: SimpleDictionaryItemSchema | null;
  /** Available Stock */
  available_stock?: number | null;
  /** Is Package Amount Editable */
  is_package_amount_editable: boolean;
  /** ProductPermissions */
  $permissions: {
    /** Add To Catalog */
    add_to_catalog?: boolean;
    /** Update */
    update?: boolean;
    /** View */
    view?: boolean;
  };
  cart_item: ProductCartItemSchema | null;
}

/** ViewProductSchema */
export interface ViewProductSchema {
  /** Title */
  title: string;
  /** Code */
  code?: string | null;
  /** Description */
  description?: string | null;
  /** Weight */
  weight?: string | null;
  /** Length */
  length?: string | null;
  /** Height */
  height?: string | null;
  /** Width */
  width?: string | null;
  /** Price */
  price?: string | null;
  /** Package Amount */
  package_amount?: number | null;
  /** Manual Stock */
  manual_stock?: number | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Uid */
  uid: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Images */
  images: ProductImageSchema[];
  /** Tags */
  tags: SimpleDictionaryItemSchema[];
  brand: SimpleDictionaryItemSchema | null;
  category: SimpleDictionaryItemSchema | null;
  /** Available Stock */
  available_stock?: number | null;
  /** Is Package Amount Editable */
  is_package_amount_editable: boolean;
  /** ProductPermissions */
  $permissions: {
    /** Add To Catalog */
    add_to_catalog?: boolean;
    /** Update */
    update?: boolean;
    /** View */
    view?: boolean;
  };
}

/** _Source */
export interface Source {
  /** Pointer */
  pointer?: string | null;
  /** Header */
  header?: string | null;
  /** Parameter */
  parameter?: string | null;
}

/** CartLimitExceededError */
export interface CartLimitExceededError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "cart_limit_exceeded";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  meta: any;
}

/** CatalogDatesNotAddableError */
export interface CatalogDatesNotAddableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "catalog_dates_not_addable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CatalogDatesNotPairedError */
export interface CatalogDatesNotPairedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "catalog_dates_not_paired";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CatalogDatesNotRemovableError */
export interface CatalogDatesNotRemovableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "catalog_dates_not_removable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** CatalogStartNotBeforeEndError */
export interface CatalogStartNotBeforeEndError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "catalog_start_not_before_end";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}
